import { render, staticRenderFns } from "./TemplateOrder.vue?vue&type=template&id=0217d8b9&scoped=true&"
import script from "./TemplateOrder.vue?vue&type=script&lang=js&"
export * from "./TemplateOrder.vue?vue&type=script&lang=js&"
import style0 from "./TemplateOrder.vue?vue&type=style&index=0&id=0217d8b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0217d8b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0217d8b9')) {
      api.createRecord('0217d8b9', component.options)
    } else {
      api.reload('0217d8b9', component.options)
    }
    module.hot.accept("./TemplateOrder.vue?vue&type=template&id=0217d8b9&scoped=true&", function () {
      api.rerender('0217d8b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PersonalCenter/TemplateOrder/TemplateOrder.vue"
export default component.exports